import React from 'react';
import {connect} from 'react-redux';
import TextInput from '../../../../Shared/TextInput/TextInput';
import {setSimCardCount} from '../../TransferOrganizationAccountSlice';

const SimCountComponent = (props) => {
  const handleInputChange = (e) => {
    const currentItem = e.nativeEvent.data;
    const regex = /^\d+$/; // Regular expression to allow only digits

    if (regex.test(currentItem) || !e.nativeEvent.data) {
      props.setSimCardCount({count: e.target.value});
    } else return null;
  };
  return (
    <div className='transfer-line-sub-step borderline'>
      <div className='M_Sub_Title'>כמה כרטיסים להזמין לך?</div>
      <div className=''>
        <TextInput
          error={props.data}
          placeholder='מספר כרטיסים'
          onChange={(e) => handleInputChange(e)}
          value={props.data.simCountOrder}
          name={'simCount'}
          type='text'
          required='required'
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    data: state.TransferOrganizationAccount,
  };
};

const mapDispatchToProps = {setSimCardCount};

export default connect(mapStateToProps, mapDispatchToProps)(SimCountComponent);
